// Magnetic buttons: the button leans toward the pointer and a brand-gradient spotlight follows it.
// Only on fine pointers with hover, and never when the visitor prefers reduced motion.
const SELECTOR = '.button-primary, .button-secondary, .button-outline';
const PULL_X = 7;
const PULL_Y = 5;

const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

let activeButton = null;

function reset(button) {
  button.style.removeProperty('--magnet-x');
  button.style.removeProperty('--magnet-y');
  button.removeAttribute('data-magnet');
}

function onPointerMove(event) {
  if (!canHover.matches || reduceMotion.matches) return;
  const target = event.target instanceof Element ? event.target.closest(SELECTOR) : null;

  if (activeButton && activeButton !== target) {
    reset(activeButton);
    activeButton = null;
  }
  if (!target || target.matches(':disabled, [aria-disabled="true"]')) return;

  const rect = target.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  const offsetX = (x - rect.width / 2) / (rect.width / 2);
  const offsetY = (y - rect.height / 2) / (rect.height / 2);

  target.style.setProperty('--spot-x', `${x}px`);
  target.style.setProperty('--spot-y', `${y}px`);
  target.style.setProperty('--magnet-x', `${(offsetX * PULL_X).toFixed(2)}px`);
  target.style.setProperty('--magnet-y', `${(offsetY * PULL_Y).toFixed(2)}px`);
  target.setAttribute('data-magnet', '');
  activeButton = target;
}

function onPointerOut(event) {
  if (!activeButton) return;
  const next = event.relatedTarget;
  if (next instanceof Node && activeButton.contains(next)) return;
  reset(activeButton);
  activeButton = null;
}

document.addEventListener('pointermove', onPointerMove, { passive: true });
document.addEventListener('pointerout', onPointerOut, { passive: true });
